import { ContextMenuItemView, EventContextMenuClickParams } from '@mark43/cad-api';
import { MenuItem } from '../../context-menus/components/menu-item';
import { useSetEventPanelModal } from '../event-panel-modals';

export function RequestAssistanceMenuItem({
    contextMenuItemView,
    clickParams,
}: {
    clickParams: EventContextMenuClickParams;
    contextMenuItemView: ContextMenuItemView;
}): React.ReactElement {
    const setEventPanelModal = useSetEventPanelModal();

    const handleSelect = (): void => {
        setEventPanelModal({
            props: {
                agencyEventId: clickParams.eventId,
            },
            type: 'REQUEST_ASSISTANCE',
        });
    };

    return <MenuItem contextMenuItemView={contextMenuItemView} onSelect={handleSelect} />;
}
